/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_No_Snapshot_HintInputs */

const vi_stocktake_no_snapshot_hint = /** @type {(inputs: Stocktake_No_Snapshot_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có chốt sổ approved cho loại lô này. Vào Chốt sổ để tạo trước.`)
};

/**

* @param {Stocktake_No_Snapshot_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_no_snapshot_hint = /** @type {((inputs?: Stocktake_No_Snapshot_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_No_Snapshot_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_no_snapshot_hint(inputs)
});